import React, { FC, useState, useEffect } from 'react';

import Paper from '@material-ui/core/Paper';

import { IAdminEvent } from '../../store/admin/events/store';

import { getEventField } from '../../contrib/Utils/getEventField';
import { navigateTo } from '../../contrib/Utils/navigateTo';
import { BackgroundImage } from '../BackgroundImage/BackgroundImage';
import Button from '../Button';
import DateBox from '../DateBox';
import { EventCardDefaultBackground } from '../../assets/images';

interface IProps {
  event: IAdminEvent;
  eventLabel?: string;
}

const EventAdminCard: FC<IProps> = props => {
  const { event, eventLabel } = props;

  const {
    club,
    id,
    image,
    name,
    start,
    totalActiveEnrollments,
    totalPlayers,
    verboseStatus
  } = event;

  const [activeClass, setActiveClass] = useState('');
  const [openings, setOpenings] = useState<number>();
  const [registeredPlayersInfo, setRegisteredPlayersInfo] = useState('');

  useEffect(() => {
    const newOpenings =
      totalPlayers > totalActiveEnrollments ? totalPlayers - totalActiveEnrollments : 0;
    setOpenings(newOpenings);
  }, [totalPlayers, totalActiveEnrollments]);

  useEffect(() => {
    setRegisteredPlayersInfo(
      `${totalActiveEnrollments || 0} of ${totalPlayers || 0} Players Registered`
    );
  }, [event]);

  useEffect(() => {
    const active = eventLabel === 'current';

    if (active) {
      setActiveClass('active');
    }
  }, [eventLabel]);

  return (
    <div className={`event-admin-card`}>
      <Paper elevation={1} className={`paper greyee-bg ${activeClass}`}>
        {!!eventLabel && (
          <div className={`event-head ${activeClass}`}>
            <h3 className={`${activeClass}`}>{eventLabel}</h3>
          </div>
        )}

        {event && (
          <>
            <BackgroundImage
              src={image || EventCardDefaultBackground}
              className="event-bg"
              alt="bg-image"
              height="calc(var(--px) * 180)"
            >
              <div className="event-admin-header-content">
                <h2>{name}</h2>
              </div>
            </BackgroundImage>

            <div className="event-content">
              <div className="event-content__info">
                <div className="status">
                  <span>{verboseStatus}</span>
                </div>

                <div className="event-content-data">
                  <div className="left">
                    <DateBox rawDate={start} />
                  </div>

                  <div className="right">
                    <p className="event-field">{getEventField(event).name}</p>

                    <span className="title">{openings} Openings</span>

                    <span className="location">{registeredPlayersInfo}</span>
                  </div>
                </div>
              </div>

              <Button
                variant="contained"
                color="primary"
                type="button"
                className="button submit"
                onClick={navigateTo(`/staff/club/${club}/event/${id}`)}
              >
                Go to event
              </Button>
            </div>
          </>
        )}
      </Paper>
    </div>
  );
};

export default EventAdminCard;
